import React, { CSSProperties } from "react";

interface CanvasProps
{
    draw(context: CanvasRenderingContext2D): void;
    autorefresh: boolean;
    initialScale: number;
}

export default class Canvas extends React.Component<CanvasProps>
{
    static defaultProps = {
        autorefresh: false,
        initialScale: 1,
    };

    private containerRef: React.RefObject<HTMLDivElement>;
    private canvasRef: React.RefObject<HTMLCanvasElement>;
    private rAF: number = 0;
    
    constructor(props: any) 
    {
        super(props);
        this.updateAnimationState = this.updateAnimationState.bind(this);
        this.canvasRef = React.createRef();
        this.containerRef = React.createRef();
    }
    
    componentDidMount()
    {
        if (this.props.autorefresh)
            this.rAF = requestAnimationFrame(this.updateAnimationState);
        new ResizeObserver(this.onContainerResize.bind(this)).observe(this.containerRef.current!);
        this.refresh();
    }

    onContainerResize() 
    {
        const canvas = this.canvasRef.current;
        if (canvas == null) 
            return;

        const cr = canvas.getBoundingClientRect();
        //console.log(cr);

        canvas.width = Math.floor(cr.width * 2);
        canvas.height = Math.floor(cr.height * 2);
        const context = canvas.getContext('2d');
        context?.scale(this.props.initialScale, this.props.initialScale);
        this.refresh();
    }
    
    updateAnimationState() 
    {
        //console.log("updateAnimationState");
        this.setState({});
        if (this.props.autorefresh)
            this.rAF = requestAnimationFrame(this.updateAnimationState);
    }
    
    componentWillUnmount()
    {
        cancelAnimationFrame(this.rAF);
    }

    render()
    {
        return (
            <div style={containerStyle} ref={this.containerRef}>
                <canvas ref={this.canvasRef} style={canvasStyle}></canvas>
            </div>
        );
    }

    componentDidUpdate() 
    {
        this.refresh();
    }

    private refresh()
    {
        const canvas = this.canvasRef.current;
        const context = canvas?.getContext("2d");
        if (!context) return;

        this.props.draw(context);
    }
}

const containerStyle: CSSProperties = {
    flexGrow: "0",
    overflowY: "hidden",
    display: "flex",
    alignItems: "stretch",
    minHeight: "0",
    height: "100%",
};

const canvasStyle: CSSProperties = {
    flexGrow: "0",
    width: "100%",
    height: "100%",
}